// ================================
// IMPORTS
// ================================
import { computed } from "vue"
import { storeToRefs } from "pinia"
import { useBuildingStore } from "@core/stores/building-v2.store"

/** Identifiants d’ancre HTML pour les blocs de la page informations générales (sidebar + scroll). */
export const BUILDING_INFO_GENERAL_SECTION_IDS = {
    address: "building-info-address",
    relation: "building-info-relation",
    building: "building-info-building",
    house: "building-info-house",
    usageProfile: "building-info-usage-profile",
    actors: "building-info-actors",
} as const

/**
 * Visibilité des blocs « informations générales » alignée sur `PageBuildingInfoGeneral`.
 * Réagit au bâtiment courant du store (ex. changement d’occupation).
 */
export function useBuildingInfoGeneralSectionVisibility() {
    const buildingStore = useBuildingStore()
    const { building } = storeToRefs(buildingStore)

    const getIsHousingCardDisplay = computed(() => {
        const occ = building.value?.infos?.occupation?.usage
        return (
            [
                "maison_individuelle",
                "immeuble_habitation_prive",
                "logements_sociaux",
                "residences",
                undefined,
                null,
            ] as (string | undefined | null)[]
        ).includes(occ as string | undefined)
    })

    const getNiveau = computed(() => building.value?.infos?.niveau ?? "")

    const getShowRelation = computed(() => !!getNiveau.value)

    const getShowBuildingBlock = computed(() =>
        ["immeuble", "groupe", "maison_immeuble"].includes(getNiveau.value)
    )

    return {
        getIsHousingCardDisplay,
        getNiveau,
        getShowRelation,
        getShowBuildingBlock,
    }
}
